import { SVGInterface } from "../../interface";

const ThreeDAlt = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3185 2.15943C11.6483 1.94686 12.072 1.94686 12.4019 2.15943L20.3185 7.2613C20.614 7.45171 20.7878 7.78325 20.7763 8.13455C20.7762 8.13832 20.776 8.14208 20.7759 8.14583H20.7768V15.6483C20.777 15.6599 20.777 15.6715 20.7768 15.6831V16.0625H20.6952C20.6153 16.2485 20.4782 16.412 20.2913 16.5242L12.3747 21.2742C12.058 21.4642 11.6624 21.4642 11.3457 21.2742L3.42901 16.5242C3.24214 16.412 3.10509 16.2485 3.02511 16.0625H2.94351V15.6831C2.94331 15.6715 2.94331 15.6599 2.94351 15.6483V8.14583H2.94448C2.94431 8.14208 2.94417 8.13832 2.94404 8.13455C2.93256 7.78325 3.10635 7.45171 3.40181 7.2613L11.3185 2.15943ZM4.94351 9.80138V15.1005L10.8602 18.6505V13.0884L4.94351 9.80138ZM12.8602 13.0884V18.6505L18.7768 15.1005V9.80138L12.8602 13.0884ZM17.8322 8.03829L11.8602 4.18967L5.8882 8.03829L11.8602 11.356L17.8322 8.03829Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default ThreeDAlt;
